<template>
    <v-dialog overlay-opacity="0.8" style="box-shadow: none;" content-class="no_elevate" v-model="pay_dialog_private" persistent max-width="290">
        <v-img width="200" class="mx-auto"  src="/api/images/qr_frame2.png" v-if="!isMobile && !visited">
          <p style="text-align: center; position: absolute; top: 28px; font-size: 11px; width: 100%;">Skanna med kamera-app <br><br>(ej Swish-appen)</p>
            <qrcode-vue style="top: 87px !important; position: relative; left: 45px;" :value="'https://hihat.io/p/'+nickname" :size="110" level="H"></qrcode-vue>


        </v-img>

        <v-img width="200" class="mx-auto"  src="/api/images/swish_stuck.png" v-if="(!isMobile && visited && status==='pending')">



        </v-img>



        <v-card >
            <v-progress-linear
                    height="30"
                    :indeterminate="status==='pending'"
                    color="#6dd6adcf"
                    :background-color="(status==='pending' || status==='done') ?  '#5dbc97eb' :'rgba(188,77,70,0.92)'"
            >
                <v-btn v-if="status==='pending'" x-small color="white" outlined>Slutför betalningen i din mobil</v-btn>
                <v-btn v-if="status==='done'" x-small color="white" outlined><v-icon small  >mdi mdi-checkbox-marked-circle-outline</v-icon>Betalad</v-btn>
                <v-btn v-if="status!=='done' && status!=='pending'" x-small color="white" outlined><v-icon small >mdi mdi-close-circle</v-icon>Ej Betalad</v-btn>



            </v-progress-linear>
            <v-card-title class="headline"></v-card-title>

            <v-list-item v-if="status==='pending'" style="text-align: center" two-line>
                <v-list-item-content>
                    <v-list-item-title style="font-size: 0.8rem;">Skanna QR-koden  eller gå till</v-list-item-title>
                    <v-list-item-title class="display-1">hihat.io/p/<span style="color:#5dbc97eb;">{{nickname}}</span></v-list-item-title>
                    <v-list-item-title style="font-size: 0.8rem;">på den mobil du har Swish installerat</v-list-item-title>

                </v-list-item-content>
            </v-list-item>
            <v-card-text v-if="status==='done'" style="text-align: center;">Donationen genomfördes 😎</v-card-text>
            <v-card-text v-if="status!=='done' && status!=='pending'" style="text-align: center;">{{error_message}}</v-card-text>










            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="status!=='done'" x-small color="red darken-1" text @click="hide">Avbryt</v-btn>
                <v-btn v-if="status==='done'" x-small color="green darken-1" text @click="done">OK</v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import QrcodeVue from 'qrcode.vue'
    export default {
        name: "SwishModalPrivateDonation",
        props:["pay_dialog_private","amount","type","nickname"],
        components:{QrcodeVue,},
        data(){
            return{
                status:"pending",
                statusTimer:null,
                payment_id:"",
                error_message:"",
                visited:false
            }
        },
        mounted:function(){

            this.status="pending";
            this.statusTimer=null;
            this.payment_id="";
            this.error_message="";
            this.visited=false
        },
        methods:{
            hide:function(){
                this.$emit("hide")
            },
            done:function(){
                this.$emit("donated")
            },
            openSwish:function(){
                window.location = '/api/'+this.nickname;
            },
            getStatus:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/paymentStatus?';

                let params = 'client_id='+this.nickname;
                http.open('POST', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {//Call a function when the state changes.

                    if(http.readyState === 4 && http.status === 401) {
                        self.status="error";

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        let data = JSON.parse(http.response);
                        if(data["error"]){
                            if(data["error"]==="not yet in db"){
                                return
                            }
                            else if(data["error"]==="visited"){
                                setTimeout(function(){
                                    self.visited=true;
                                },8000);

                                return
                            }
                            else{
                                self.visited=false;
                                self.status=data["error"];

                            }
                        }
                        else if(!data["is_paid"]){
                            self.visited=false;
                            self.status=data["cause"];

                        }
                        else if(data["is_paid"]){
                            self.visited=false;
                            self.status="done";
                            self.payment_id=data["message_id"]

                        }
                    }
                };
                http.send(params);
            }
        },
        computed:{
            isMobile() {
                let check = false;
                (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
                return check;
            }
        },
        watch:{
            nickname:function(){
                this.status="pending";
                this.statusTimer=null;
                this.payment_id="";
                this.error_message="";
                this.visited=false;
                if(this.nickname){
                    if(this.isMobile){
                        this.openSwish();
                    }
                    let self=this;
                    this.statusTimer=setInterval(function(){
                        self.getStatus() }, 1000);
                }
            },
            status:function(){
                if(this.status!=="pending"){
                    clearInterval(this.statusTimer);
                    if(this.status!=="pending" && this.status!=="done"){
                        if(this.status==="error"){
                            this.error_message="Ett fel inträffade🤔";
                        }
                        else if(this.status==="timed out"){
                            this.error_message="Betalningen avbröts på grund av inaktivitet😴";
                        }
                        else if(this.status==="busy"){
                            this.error_message="Du har redan en pågående betalning. Gör klart den eller vänta någon minut😒";
                        }
                        else if(this.status==="notpaid" || this.status==="declined"){
                            this.error_message="Donationen genomfördes ej 😥";
                        }
                        else if(this.status==="notallowed"){
                            this.error_message="Du kan för tillfället ej utföra donationer via Hihat";
                        }
                    }

                }
            }
        }
    }
</script>

<style scoped>

</style>
